import React, { useState, /*useEffect*/ } from "react";
import styles from "./ShabanResult.module.scss";
import { ShabanResultType } from "types";
import Text from "components/text/Text";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import strings from "assets/strings";
import PhoneLink from "components/phoneLink/PhoneLink";

export const ShabanResult = ({ hit }: { hit: ShabanResultType }) => {
  const [showHospitalOptions, setShowHospitalOptions] = useState(false);

  return (
    <>
      <div className={styles.hitShaban}>
        <div className={styles.distanceSection}>
          {hit._rankingInfo?.geoDistance && (
            <Text className={styles.textTitle2} text={`${(hit._rankingInfo.geoDistance / 1000).toFixed(2)} ק"מ`} />
          )}
        </div>
        <div className={styles.amountToggleTitle}>
          <span className={styles.route}>{`${strings.operationSearchResults.route} ${!hit.surgeonIsKupa ? strings.operationSearchResults.public : strings.operationSearchResults.shaban}`}</span>
        </div>
        <div className={styles.medicalCenterDetails}>
          <div className={styles.section2}>
            <SvgGenerator name="Operation" className={styles.avatar} objectName="operationsSearchResults" title="מנתח" />
            <div className={styles.divText}>
              {`${hit.title} ${hit.fullName}`}
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.divText}>
              <Text
                className={styles.textTitle2}
                text={strings.globalStrings.address}
              />
              {hit.address && hit.address.map(address => (
                <Text
                  className={styles.textAddress}
                  text={`${address?.city || ''} ${address?.street || ''} ${address?.houseNumber || ''}`}
                />
              ))}
            </div>
          </div>

          <div className={styles.section}>
            <div className={styles.divText}>
            <Text text={strings.doctorSearchResults.callToOrder} className={styles.textTitle2} />
                {/* <PhoneLink phoneNumber={hit.address[0].phone || ''} />
                <PhoneLink phoneNumber={hit.address[0].phone || ''} /> */}
                {hit.address && hit.address.map((address) => (
                <PhoneLink phoneNumber={address.phone || ''} />
              ))}
            </div>
          </div>
          
        </div>
        <div className={styles.amountToggleTitle} onClick={() => setShowHospitalOptions(!showHospitalOptions)} >
          <span className={styles.participationSum}>{strings.medicalCentersSearchResults.participationAmount}</span>
          {showHospitalOptions ? <SvgGenerator name="ArrowUp2" className={styles.arrowIcon} objectName="medicalCenterSearchResults" /> : <SvgGenerator name="ArrowLeft2" className={styles.arrowIcon} objectName="medicalCenterSearchResults" />}
        </div>

        {showHospitalOptions && <div className={styles.optionsContainer}>
          <div className={styles.pricesSection}>
            {hit.costHospitals.map((hospital, index) => (
              <div key={index}>
                <div className={styles.priceItem}>
                  <div className={styles.categoryType}>
                    <Text
                      className={styles.titleHospital}
                      text={hospital.hospitalName}
                    />
                  </div>
                  {!hit.surgeonIsKupa ? <Text className={styles.titleHospital} text={strings.operationSearchResults.surgeonIsKupa} /> :
                    <div className={styles.prices}>

                      <Text className={styles.titleHospital} text={strings.operationSearchResults.deductible} />
                      <SvgGenerator name="Silver" className={styles.levelIcon} objectName="operationsSearchResults" />                      
                      <Text text={strings.operationSearchResults.silver} />
                      <Text
                        className={styles.titleHearring}
                        text={`${Number(hospital.leumitSilverPrice.split('.')[0]).toLocaleString()} ₪`}
                      /><div className={styles.separator} />
                      <SvgGenerator name="Gold" className={styles.levelIcon} objectName="operationsSearchResults" />
                      <Text text={strings.operationSearchResults.gold} />
                      <Text
                        className={styles.titleHearring}
                        text={`${Number(hospital.leumitGoldPrice.split('.')[0]).toLocaleString()} ₪`}
                      />
                    </div>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>}
      </div>

    </>
  );
};
